import React from 'react';
import { FormattedMessage } from 'react-intl';

// TODO: check types, its temporary
import DialogActionsMui from '@mui/material/DialogActions';
import ButtonMui from '@mui/material/Button';

const Dialog = ({ okText, cancelText, onCancel, onOk, okBtnProps, cancelBtnProps, forFormID, ...rest }) => (
  <DialogActionsMui {...rest}>
    <ButtonMui variant="text" onClick={onCancel} {...cancelBtnProps}>
      {cancelText || <FormattedMessage id="button.cancel" defaultMessage="Cancel" />}
    </ButtonMui>
    <ButtonMui onClick={onOk} type="button" form={forFormID} {...okBtnProps}>
      {okText || <FormattedMessage id="button.ok" defaultMessage="Ok" autoFocus />}
    </ButtonMui>
  </DialogActionsMui>
);

export default Dialog;
